module.exports = __webpack_public_path__ + "img/home_ma2.76246013.jpg";